<template>
    <v-badge
      v-if="badgeText!=''"
      :content="badgeText"
      color="red"
      overlap
      offset-x="2"
      offset-y="2"
    >
      <span>
        <v-icon v-if="svgContent !== '' && isSVG" :size="sizeIcon>0?sizeIcon:defaultIconSize" v-html="svgContent"></v-icon>
        <v-icon v-if="!isSVG" :size="sizeIcon > 0 ? sizeIcon:defaultIconSize">
          <v-img
          :src="url"
          />
        </v-icon>
    </span>
  </v-badge>
  <span  v-if="badgeText==''">
        <v-icon v-if="svgContent !== ''&&isSVG" :size="sizeIcon>0?sizeIcon:defaultIconSize" v-html="svgContent"></v-icon>
        <v-icon v-if="!isSVG" :size="sizeIcon>0?sizeIcon:defaultIconSize">
          <v-img
          :src="url"
          />
        </v-icon>
    </span>
</template>

<script setup>
import { ref, onMounted } from "vue";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  sizeIcon: {
    type: Number,
    default: 0,
  },
  badgeText:{
    type: [String, Number],
    required: false,
    default:""
  }
});
const { PUBLIC_DATA_URL } = useRuntimeConfig().public
const isDev = process.env.NODE_ENV !== 'production'
const isSVG = ref(false)
const svgContent = ref("");

onMounted(async () => {
  let urlSVG = props.url
  if (urlSVG.endsWith('.svg')) {
    isSVG.value = true;
    try {

      if (!urlSVG.startsWith("/")){
        urlSVG = "/"+ urlSVG
      }
      // if not starts with /PUBLIC/BINARY add otherwise the svg may cause an 404 response on the router
      if (!urlSVG.startsWith('/PUBLIC/BINARY' )){
        urlSVG = '/PUBLIC/BINARY'+urlSVG
      }

      // Replace /PUBLIC with PUBLIC_DATA_URL in development environment to load icons correctly from bucket
      if (isDev){
        urlSVG = urlSVG.replace("/PUBLIC", PUBLIC_DATA_URL)
      }

      // fetch svg file from public chare
      const response = await fetch(urlSVG);

      // Check response status
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      svgContent.value = await response.text();

    } catch (error) {
      console.error("Error loading SVG " +urlSVG+": " + error.message);
    }
  }
});



const defaultIconSize = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 25;
    case "sm":
      return 29;
    case "md":
      return 29;
    case "lg":
      return 33;
    case "xl":
      return 36;
    case "xxl":
      return 36;
    default:
      return 0;
  }
});

</script>
